import { useQuery } from '@tanstack/react-query';
import apiClient from '@/lib/api-client';

export interface EmbeddingModelOption {
  model_id: string;
  display_name: string;
  provider_type: string;
  dimensions: number | null;
  max_input_tokens: number | null;
  is_default: boolean;
}

export const EMBEDDING_PROVIDER_LABELS: Record<string, string> = {
  voyage: 'Voyage AI',
  azure_foundry: 'Azure AI Foundry',
  vertex_ai: 'Vertex AI',
  aws_bedrock: 'AWS Bedrock',
};

export function embeddingProviderLabel(providerType: string): string {
  return EMBEDDING_PROVIDER_LABELS[providerType] ?? providerType;
}

const EMBEDDING_MODELS_KEY = ['embedding-models'];

export function useEmbeddingModels() {
  return useQuery({
    queryKey: EMBEDDING_MODELS_KEY,
    queryFn: async () => {
      const response = await apiClient.get<{ items: EmbeddingModelOption[] }>(
        '/api/v1/admin/embedding-models'
      );
      return response.data.items;
    },
    staleTime: 300_000,
  });
}
